<div class="section-settings" *ngIf="currentUser">
  <div class="container-fluid h-100">
    <div class="row p-0 h-100">

      <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xxl-2" style="border-right: 1px solid lightgray;">

        <div class="hide-sm hide-md">
          <nav class="nav flex-column mt-3">
            <a class="nav-link" routerLinkActive="active" routerLink="/settings/account">Account</a>
            <a class="nav-link" routerLinkActive="active" routerLink="/settings/membership" *ngIf="currentUser.role === 'customer'">Membership</a>
            <a class="nav-link" routerLinkActive="active" routerLink="/settings/verification" *ngIf="currentUser.role === 'customer'">Verification</a>
            <a class="nav-link" routerLinkActive="active" routerLink="/settings/referrals" *ngIf="currentUser.role === 'customer' && !currentUser.company">Referrals</a>
            <a class="nav-link" routerLinkActive="active" routerLink="/settings/payments" *ngIf="currentUser.role === 'customer' && !currentUser.company">Payment History</a>
            <a class="nav-link" routerLinkActive="active" routerLink="/settings/extra" *ngIf="currentUser.role === 'customer' && !currentUser.company && isMembershipAllowedExtraHours">Need more hours?</a>
          </nav>
        </div>

        <div class="hide-lg hide-xl hide-xxl">
          <br/>
          <div class="btn-group w-100">
            <button type="button" class="btn btn-block btn-white text-start" data-bs-toggle="dropdown" aria-expanded="false">
              <span [ngSwitch]="currentPath">
                <span *ngSwitchCase="'/settings/account'">Account</span>
                <span *ngSwitchCase="'/settings/membership'">Membership</span>
                <span *ngSwitchCase="'/settings/membership/adjust'">Membership</span>
                <span *ngSwitchCase="'/settings/membership/cancel'">Membership</span>
                <span *ngSwitchCase="'/settings/membership/reactivate'">Membership</span>
                <span *ngSwitchCase="'/settings/membership/pause'">Membership</span>
                <span *ngSwitchCase="'/settings/verification'">Verification</span>
                <span *ngSwitchCase="'/settings/referrals'">Referrals</span>
                <span *ngSwitchCase="'/settings/payments'">Payment History</span>
                <span *ngSwitchCase="'/settings/extra'">Need more hours?</span>
                <span *ngSwitchDefault>Settings</span>
              </span>
              <span class="dropdown-toggle"></span>
            </button>
            <ul class="dropdown-menu w-100">
              <li><h6 class="dropdown-header">Settings</h6></li>
              <li><a class="dropdown-item" routerLinkActive="active" routerLink="/settings/account">Account</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" routerLink="/settings/membership" *ngIf="currentUser.role === 'customer'">Membership</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" routerLink="/settings/verification" *ngIf="currentUser.role === 'customer'">Verification</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" routerLink="/settings/referrals" *ngIf="currentUser.role === 'customer' && !currentUser.company">Referrals</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" routerLink="/settings/payments" *ngIf="currentUser.role === 'customer' && !currentUser.company">Payment History</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" routerLink="/settings/extra" *ngIf="currentUser.role === 'customer' && !currentUser.company && isMembershipAllowedExtraHours">Need more hours?</a></li>
            </ul>
          </div>
          <br/>
          <hr class="mt-4"/>
        </div>

      </div>

      <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xxl-10">
        <div class="section-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>

  </div>
</div>
